/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Free_NameInputs */

const en_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const de_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos`)
};

const fr_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit`)
};

const es_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const it_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const nl_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const pl_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darmo`)
};

const fi_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmainen`)
};

const da_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

const sv_pricing_plan_free_name = /** @type {(inputs: Pricing_Plan_Free_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Pricing_Plan_Free_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_free_name = /** @type {((inputs?: Pricing_Plan_Free_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Free_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_free_name(inputs)
	if (locale === "fr") return fr_pricing_plan_free_name(inputs)
	if (locale === "es") return es_pricing_plan_free_name(inputs)
	if (locale === "it") return it_pricing_plan_free_name(inputs)
	if (locale === "nl") return nl_pricing_plan_free_name(inputs)
	if (locale === "pl") return pl_pricing_plan_free_name(inputs)
	if (locale === "fi") return fi_pricing_plan_free_name(inputs)
	if (locale === "da") return da_pricing_plan_free_name(inputs)
	if (locale === "sv") return sv_pricing_plan_free_name(inputs)
	return en_pricing_plan_free_name(inputs)
});